<template>
    <div style="text-align: center;">
        <y-shelf title="拉黑设计师">
            <div slot="content" class="desHeader">
                <div style="height: 600px;">
                    <div class="transfer">
                        <el-row :gutter="30" class="condition-table">
                            <!-- 左侧 -->
                                <el-col :span="10" style="padding-left:0">
                                    <div class="no-add">
                                        <span>候选列表</span>
                                    </div>
                                    <div style="width: 100%;height: 40px;">
                                        <el-input class="el-transfer-panel__filter" v-model="queryLeftParam.nickName"
                                            size="small" placeholder="请输入设计师名称" @input="filterLeftParam">
                                            <i slot="prefix" class="el-icon-search search-position"></i>
                                        </el-input>
                                    </div>
                                    <el-table ref="staffTable" border v-loading="loading"
                                    style="height: 500px;overflow-y: auto;"
                                        :row-key="getRowKeyLeft" :data="leftDesList"
                                        @selection-change="handleStaffChange"
                                        :header-cell-style="{ background: '#f5f8ff' }">
                                        <el-table-column type="selection" align="center" :reserve-selection="true"
                                            width="55"></el-table-column>
                                        <el-table-column label="编号" align="center" show-overflow-tooltip>
                                            <template slot-scope="{ row }">
                                                <span>{{row.userCode}}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="名称" align="center" show-overflow-tooltip>
                                            <template slot-scope="{row}">
                                                <span>{{ row.nickName }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="操作" align="center" show-overflow-tooltip>
                                            <template slot-scope="{row}">
                                                <el-button @click="addItemToRightList({ row })">添加</el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <div class="table-footer">
                                        <el-pagination @current-change="leftPageNum" :pager-count="5"
                                            :current-page.sync="queryLeftParam.pageNum"
                                            :page-size="queryLeftParam.pageSize" layout="prev, pager, next"
                                            :total="leftTotal" style="margin-top: 1%;">
                                        </el-pagination>
                                    </div>
                                </el-col>
                                <!-- 多选移动箭头图标 -->
                                <div class="icon-center">
                                    <p class="icon-right-if icon-return" @click="addStaff()"
                                        v-if="selectLeftData.length > 0">
                                        <i class="el-icon-arrow-left"></i>
                                    </p>
                                    <p class="icon-right-else icon-return" v-else>
                                        <i class="el-icon-arrow-left"></i>
                                    </p>
                                    <p class="icon-right-if" @click="removeStaff()"
                                        v-if="selectRightData.length > 0">
                                        <i class="el-icon-arrow-left"></i>
                                    </p>
                                    <p class="icon-right-else" v-else>
                                        <i class="el-icon-arrow-left"></i>
                                    </p>
                                </div>
                                <!-- 右侧 -->
                                <el-col :span="10" style="padding-right:0">
                                    <div class="no-add">
                                        <span>拉黑列表</span>
                                    </div>
                                    <div style="width:100%;height: 40px;">
                                        <el-input class="el-transfer-panel__filter" v-model="queryRightParam.nickName"
                                            size="small" placeholder="请输入设计师名称" @input="filterRightParam">
                                            <i slot="prefix" class="el-icon-search search-position"></i>
                                        </el-input>
                                    </div>
                                    <el-table ref="selectedStaffTable" border v-loading="loading"
                                        :row-key="getRowKeyRight" :data="rightDesList"
                                        @selection-change="handleSelectedStaffChange"
                                        :header-cell-style="{ background: '#f5f8ff' }"
                                        style="height: 500px;overflow-y: auto;">
                                        <el-table-column type="selection" align="center" :reserve-selection="true"
                                            width="55"></el-table-column>
                                        <el-table-column label="编号" align="center" show-overflow-tooltip>
                                            <template slot-scope="{ row }">
                                                 <span>{{row.userCode}}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="名称" align="center" show-overflow-tooltip>
                                            <template slot-scope="{row}">
                                                <span>{{ row.nickName }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="操作" align="center" show-overflow-tooltip>
                                            <template slot-scope="{row}">
                                                <el-button @click="addItemToLeftList({ row })">移除</el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <div class="table-footer">
                                        <el-button class="handle-btn" type="primary" plain size="mini"
                                            @click="handleSubmit">保存</el-button>
                                    </div>
                                </el-col>
                        </el-row>
                    </div>
                </div>
            </div>
        </y-shelf>
        <!-- unChangeLeft:{{unChangeLeft}} -->
        <br/><hr>
        <!-- unChangeRight:{{unChangeRight}} -->
        <br/><hr>
        <!-- leftDesList:{{leftDesList}} -->
        <br/><hr>
        rightDesList:{{rightDesList}}
        <br/><hr>
        <!-- selectLeftData:{{selectLeftData}} -->
        <br/><hr>
        <!-- selectRightData:{{selectRightData}} -->
    </div>
</template>
<script>
import YShelf from '/components/YShelf';
export default {
    data() {
        return {
            queryRightParam: {
                nickName: '',
            },
            queryLeftParam: {
                pageNum: 1,
                pageSize: 30,
                nickName: '',
            },
            unChangeLeft:[],//获取后的左侧列表数据
            unChangeRight:[],//获取后的右侧列表数据
            leftDesList: [],//左边表格数据
            rightDesList: [], //右边表格数据
            selectLeftData: [],//左边选中列表
            selectRightData: [],//右边选中列表
            loading: false,
            leftTotal: 0,
            leftList: [],//没有分页检索的全部des数据
            rightList: [],//筛选前右列表
            desListFlag: false,//判断add/edit=>url
            userId: '',//右侧列表当前用户id
        };
    },
    methods: {
        //右侧列表检索过滤
        filterRightParam() {
            if (this.queryRightParam.nickName != '') {
                this.rightDesList = this.rightDesList.filter(item => {
                    return item.nickName.substring(0, 1)==this.queryRightParam.nickName || item.userCode.toString().includes(this.queryRightParam.nickName);
                });
            } else {
                this.rightDesList = this.rightList;
            }
        },
        //左侧列表检索过滤
        filterLeftParam() {
            if (this.queryLeftParam.nickName != '') {
                this.leftDesList = this.leftList.filter(item=>{
                    return item.nickName.substring(0, 1)==this.queryLeftParam.nickName || item.userCode.toString().includes(this.queryLeftParam.nickName);
                }).map(item=>{
                    return {
                        ...item,
                        nickName: this.showName(item.nickName)
                    };
                })
                this.leftTotal = this.leftDesList.length;
            } else {
                this.loadLeftList();
            }
        },
        // 获取左侧列表数据
        loadLeftList() {
            this.$api.post({
                url: `/user/desUserList?pageNum=${this.queryLeftParam.pageNum}&pageSize=${this.queryLeftParam.pageSize}&nickName=${this.queryLeftParam.nickName}`
            }).then(res => {
                this.leftDesList = res.rows;
                this.leftTotal = res.total;
                for(let i = 0;i < this.leftDesList.length;i++){
                    //遍历每项的name，隐藏名字，显示：张**
                    this.leftDesList[i].nickName = this.showName(this.leftDesList[i].nickName);
                }
                this.unChangeLeft = [...this.leftDesList];
            })
        },
        // 右侧列表获取数据
        loadRightList() {
            this.rightDesList = [];
            this.$api.get({
                url: '/biz/blockDes/list',
            }).then(res => {
                let num = 9999;
                this.userId = res.data[0].id;
                this.$api.post({
                    url: `/user/desUserList?pageSize=${num}`
                }).then(des => {
                    this.leftList = des.rows;
                    if(res.data.length>0){
                        // 根据获取的desUserIds找左侧的设计师数据
                        let list = res.data[0].desUserIds.split(',');
                        for (let j = 0; j < list.length; j++) {
                            for (let i = 0; i < this.leftList.length; i++) {
                                if (list[j] == this.leftList[i].userId && this.rightDesList.indexOf(this.leftList[i]) == -1) {
                                    this.leftList[i].nickName = this.showName(this.leftList[i].nickName);
                                    this.rightDesList.push(this.leftList[i]);
                                }
                            }
                        }
                        this.desListFlag = res.data[0].desUserIds.split(',').length > 0 ? true : false;
                    }
                    this.rightList = [...this.rightDesList];
                    this.unChangeRight = [...this.rightDesList];
                })
            })
        },
        // 行数据的Key
        getRowKeyLeft(row) {
            return row.id;
        },
        getRowKeyRight(row) {
            return row.id;
        },
        // 左侧列表当前页数
        leftPageNum(current) {
            this.queryLeftParam.pageNum = current;
            this.loadLeftList();
        },
        // 将左边表格选择项存入selectLeftData中(后面与右边的对比，右边已存在再不添加)
        handleStaffChange(rows) {
            this.selectLeftData = [];
            if (rows) {
                rows.forEach(row => {
                    if (row) {
                        this.selectLeftData.push(row);
                    }
                });
            }
        },
        // 左边表格选择项移到右边
        addStaff() {
            let repeat = false;
            setTimeout(() => {
                if(this.$refs["staffTable"]){
                    this.$refs["staffTable"].clearSelection();
                }
                if(this.$refs["selectedStaffTable"]){
                    this.$refs["selectedStaffTable"].clearSelection();
                }
            }, 0);
            for (const item of this.rightDesList) {
                if (this.selectLeftData[0] && item.userId === this.selectLeftData[0].userId) {
                    repeat = true;
                    this.$message.error(`该设计师已添加`);
                    return false;
                }
            }
            if (!repeat) {
                // 左侧列表add
                this.selectLeftData.forEach(item => {
                    this.rightDesList.push(item);
                    this.unChangeRight.push(item);
                });
            }
            this.rightList = this.rightDesList;
            this.leftTotal = this.leftList.length;
            this.leftDesList = [...this.unChangeLeft];
            this.queryLeftParam.nickName = '';
        },
        // 右边表格选择项移到左边
        removeStaff() {
            setTimeout(() => {
                if(this.$refs["staffTable"]){
                    this.$refs["staffTable"].clearSelection();
                }
                if(this.$refs["selectedStaffTable"]){
                    this.$refs["selectedStaffTable"].clearSelection();
                }
            }, 0);
            // 右侧列表移除(筛选过滤后的)
            for (let i = 0; i < this.unChangeRight.length; i++) {
                for (let j = 0; j < this.selectRightData.length; j++) {
                    if (this.unChangeRight[i] && this.selectRightData[j] && this.unChangeRight[i].userId === this.selectRightData[j].userId) {
                        this.unChangeRight.splice(i, 1);
                    }
                }
            }
            // this.leftList = this.leftDesList;
            this.rightDesList = [...this.unChangeRight];
            this.queryRightParam.nickName = '';
        },
        // 将右边表格选择项存入selectRightData中
        handleSelectedStaffChange(rows) {
            this.selectRightData = [];
            if (rows) {
                rows.forEach(row => {
                    if (row) {
                        this.selectRightData.push(row);
                    }
                });
            }
        },
        // 按钮保存提交
        handleSubmit() {
            // 修改右侧列表,重新获取列表数据
            let url = this.desListFlag ? '/biz/blockDes/edit' : '/biz/blockDes/add';
            let desUserIds = [];
            for (let i = 0; i < this.rightDesList.length; i++) {
                let val = this.rightDesList[i].userId;
                desUserIds.push(val);
            }
            this.$api.post({
                url: url,
                data: {
                    id:this.userId,
                    desUserIds: desUserIds.toString()
                }
            }).then(res => {
                if (res.code == 200) {
                    this.$message.success(res.msg);
                    this.loadRightList();
                    this.loadLeftList();
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
        // 单项添加到右列表
        addItemToRightList(row) {
            this.selectLeftData = [];
            this.selectLeftData.push(row.row);
            this.addStaff();
            this.$nextTick(() => {
                this.selectLeftData = [];
            })
        },
        // 单项添加到左对列表
        addItemToLeftList(row) {
            this.selectRightData = [];
            this.selectRightData.push(row.row);
            this.removeStaff();
            this.$nextTick(() => {
                this.selectRightData = [];
            })
        },
        showName(name){
            let value = '';
            if(name.length<=2){
                value = name.substring(0, 1)+'*';
            }else{
                value = name.substring(0, 1)+'**';
            }
            return value;
        }
    },
    created() {
        this.loading = true;
        this.loadLeftList();
        this.loadRightList();
        this.loading = false;
    },
    components: {
        YShelf,
    }
}
</script>
<style lang="scss" scoped>
.transfer-footer {
    margin-left: 15px;
    padding: 6px 5px;
}

.desHeader {
    height: 700px;
}

.transfer {
    width: auto;
    padding: 30px;

    .condition-table {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .el-icon-arrow-left {
        font-size: 21px !important;
        background: #d9d9d9;
        border-radius: 4px;
        color: #fff;
        padding: 2px;
    }

    /deep/ .el-popover__reference-wrapper {
        vertical-align: middle !important;
        padding-left: 4px;
    }

    .icon-right-if .el-icon-arrow-left {
        background: #409eff;
        color: #fff;
    }

    .icon-center {
        i {
            margin-top: 8px;

            &:hover {
                cursor: pointer;
            }
        }

        .icon-return {
            transform: rotate(180deg);
        }
    }

    .no-add {
        display: flex;
        justify-content: space-between;
        height: 35px;
        line-height: 35px;
        line-height: 35px;
        font-size: 14px;
        margin-bottom: 10px;
        // background: #F5F7FA;

        span {
            color: #333;
            font-size: 18px;
            margin-left: 20px;
        }
    }
}

.el-transfer-panel__filter {
    width: 100%;
    height: 32px;
    font-size: 12px;
    display: inline-block;
    box-sizing: border-box;
    border-radius: 16px;
    padding-right: 10px;
    margin: 0;
}

.table-footer {
    width: 100%;
    height: 40px;
    border: 1px solid #EBEEF5;
}

.handle-btn {
    margin: 5px 0 0 -75%;
}

.search-position {
    line-height: 33px;
    margin-left: 12px;
}
</style>



// WEBPACK FOOTER //
// blockDesList.vue?2e1dc002